require('./bootstrap');
require('./core')
window.Vue = require('vue');
window.Vue.config.productionTip = false
import jumper from './plugins/jumper'
window.Vue.use(jumper)
// TODO decide if to mix "Jumper's Bus" with the global EventBus
window.EventBus = new window.Vue({
    created() {
        this.$on('navigate', this.navigate)
    },
    methods: {
        navigate(payload) {
            window.location.href = payload.url
        },
    }
})
import vuetify from './plugins/vuetify'
window.vuetify = vuetify
require('./components')
